export enum ScheduleDataState {
    pending = 1,
    validated = 2,
    canceled = 3
}
